import React from 'react';
import { Avatar as AntAvatar } from 'antd';
import type { AvatarProps } from 'antd';
import clsx from 'clsx';

export const Avatar = ({ className, ...props }: AvatarProps) => (
  <AntAvatar {...props} className={clsx('wk-avatar', className)} />
);

Avatar.Group = AntAvatar.Group;
